import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { type FormEvent, useState } from "react";

import { api, ApiClientError } from "../api";

export function SubscriptionForm({
  idPrefix,
  label = "Email address",
  buttonLabel = "Subscribe for updates",
  placeholder = "name@organization.org",
}: {
  idPrefix: string;
  label?: string;
  buttonLabel?: string;
  placeholder?: string;
}) {
  const [email, setEmail] = useState("");
  const [notice, setNotice] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const emailId = `${idPrefix}-email`;

  const subscribe = async (event: FormEvent) => {
    event.preventDefault();
    if (busy) return;
    setBusy(true);
    setError("");
    setNotice("");
    try {
      const result = await api<{ message: string }>("/api/public/waitlist", {
        method: "POST",
        body: JSON.stringify({ email }),
      });
      setNotice(result.message);
      setEmail("");
    } catch (caught) {
      setError(
        caught instanceof ApiClientError
          ? caught.message
          : "Unable to subscribe right now.",
      );
    } finally {
      setBusy(false);
    }
  };

  return (
    <form
      className="subscribe-form"
      onSubmit={(event) => void subscribe(event)}
      aria-busy={busy}
    >
      <label htmlFor={emailId}>{label}</label>
      <div className="subscribe-fields">
        <FontAwesomeIcon icon={faEnvelope} aria-hidden="true" />
        <input
          id={emailId}
          type="email"
          autoComplete="email"
          value={email}
          disabled={busy}
          onChange={(event) => {
            setEmail(event.target.value);
            setNotice("");
            setError("");
          }}
          placeholder={placeholder}
          required
        />
        <button className="button" disabled={busy}>
          {busy ? "Submitting…" : buttonLabel}
        </button>
      </div>
      {notice ? (
        <div className="alert alert-success" role="status">
          {notice}
        </div>
      ) : null}
      {error ? (
        <div className="alert alert-error" role="alert">
          {error}
        </div>
      ) : null}
    </form>
  );
}
